import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ReportSummary } from "src/app/models/models";
import { Ts1ReportPreviewContext } from "../ts1-report-preview.utils";

@Component({
	selector: "app-ts1-v4-report-summary",
	templateUrl: "./ts1-v4-report-summary.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class Ts1V4ReportSummaryComponent {
	@Input() reportSummary?: ReportSummary;
	@Input() previewContext: Ts1ReportPreviewContext | null = null;
	@Input() candidateId = "";
}
